import { AxiosResponse } from "axios";
import { axiosPrivate } from "./axios";

export const getProducts = async (): Promise<AxiosResponse> => {
  return await axiosPrivate.get('/api/exo/products');
};
